import { render } from "./KnowHowContent.vue?vue&type=template&id=9ddfc6b0"
import script from "./KnowHowContent.vue?vue&type=script&lang=js"
export * from "./KnowHowContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__